import { isNaN } from './isNaN.js';

function isNumber(value) {
    return typeof value === 'number' && !isNaN(value);
}

export { isNumber };
